require("materialize-loader");
require('materialize-css/dist/js/materialize.js');
require('./app.tag.slim');
require('./page-404.tag.slim');
require('./page-index.tag.slim');
require('./page-index-committee.tag.slim');
require('./page-index-carousel.tag.slim');
require('./page-index-exhibition.tag.slim');
require('./page-index-exhibition-half.tag.slim');
require('./page-program.tag.slim');
require('./page-program-time-table.tag.slim');
require('./page-program-invited-speakers.tag.slim');
require('./page-program-invited-speaker.tag.slim');
require('./page-awards.tag.slim');
require('./page-proceedings.tag.slim');
require('./page-proceedings-previous.tag.slim');
require('./page-venue.tag.slim');
require('./page-registration.tag.slim');
require('./layout.tag.slim');
require('./layout-menu.tag.slim');
require('./raw.tag.slim');

riot.mount('*');



// WEBPACK FOOTER //
// ./src/scripts/index.js